export default class {
  constructor (array = [], number = 10) {
    this.array = array
    this.index = 0
    this.number = number
  }

  next () {
    const value = this.array.slice(this.number * this.index, this.number * ++this.index)
    return { done: !value.length, value }
  }
}
